import React, { useEffect, useState } from "react";
import { Card, Col, Input, Row } from "reactstrap";
import { connect } from "react-redux";
import GetSettingWorkflowTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/GetSettingWorkflowTaskService";
import UpdateTaskActiveStatusService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskActiveStatusService";
import UpdateTaskRolesForTaskService from "../../../../../../../Service/OPSServices/WorkflowsService/UpdateTaskRolesForTaskService";
function WorkflowSettings(props) {
  // const [currentPhaseId, setCurrentPhaseId] = useState(props.workflowPhases && props.workflowPhases[0] ? props.workflowPhases[0].id : 0);
  const [currentPhaseId, setCurrentPhaseId] = useState(props.flag == false ? (props.workflowPhases && props.workflowPhases[0]) ? props.workflowPhases[0].id : 0 : props.selectedTask && props.selectedTask.phaseId);
  const [taskList, setTaskList] = useState([]);
  const [allTasks, setAllTasks] = useState([]);
  const [workflowPhaseCount, setWorkflowPhaseCount] = useState([]);
  const [totalWorkflowPhaseCount, setTotalWorkflowPhaseCount] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoding] = useState(false);
  const [rolesList, setRolesList] = useState([]);
  const [changedRoles, setChangedRoles] = useState({});
  const [selectedRoleFilter, setSelectedRoleFilter] = useState("");
  useEffect(function () {
    setLoding(true);

    var data = {
      settingsWorkflowId: props.settingsWorkflowId,
    };

    GetSettingWorkflowTaskService(props.token, data).then(function (res) {
      if (res) {
        console.log(res)
        setTaskList(res.tasklist || []);
        setAllTasks(res.tasklist || []);
        setRolesList(res.rolesList || []);
        setLoding(false);
      }
    });
  },[props.settingsWorkflowId]);

  const handleSearchInputChange = (e) => {
    var value = e.target.value;
    setSearchInput(value);

    // If input empty → reset data
    if (!value) {
      setTaskList(allTasks);
      return;
    }

    // Filter safely
    var filtered = allTasks.filter(function (task) {
      return (task.taskText || "")
        .toLowerCase()
        .includes(value.toLowerCase());
    });

    setTaskList(filtered);
  };

  const handleRoleChange = (taskId, value) => {
    setChangedRoles((prev) => ({
      ...prev,
      [taskId]: value,
    }));
   let data={
    taskId:taskId,
    roleId:value
   }
    UpdateTaskRolesForTaskService(props.token, data).then((res)=>{
        console.log(res);
    })
  };

  const handleActiveChange = function (task) {
    const newStatus = !task.isActive;
  
    var updated = taskList.map(function (t) {
      if (t.id === task.id) {
        return { ...t, isActive: newStatus };
      }
      return t;
    });
  
    setTaskList(updated);
  
    // API call
    UpdateTaskActiveStatusService(props.token, {
      taskId: task.id,
      isActive: newStatus,
    }).then((res) => {
      console.log("Updated successfully", res);
    });
  };


  const getFilteredTasks = () => {
    return taskList.filter(function (task) {
  
      // Phase filter
      var phaseMatch =
        !currentPhaseId ||
        Number(task.WorkflowPhases) === Number(currentPhaseId);
  
      // Role filter
      var roleMatch = true;
  
      if (selectedRoleFilter) {
        roleMatch =
          task.roleId &&
          Number(task.roleId) === Number(selectedRoleFilter);
      }
  
      return phaseMatch && roleMatch;
    });
  };
  
  return (
    <>
      <Card className="pr-3 pl-3 pt-1 pb-1 mb-2  card-of-problemarea mt-3">
        <Row>
          <Col md={12}>
            <div className="d-flex justify-content-between mt-2">
              {props.workflowMainCategory && props.workflowMainCategory.map((workMC) =>
                workMC.id == props.settingsWorkflowId ? (
                  <h5 className="mb-0 mt-2">
                    <b>{workMC.name} </b>
                  </h5>
                ) : (
                  ""
                )
              )}
                {/* Role Filter */}
                <select
                    className="form-control w-25 ml-2"
                    value={selectedRoleFilter}
                    onChange={(e) => setSelectedRoleFilter(e.target.value)}
                  >
                    <option value="">--All Roles--</option>

                    {rolesList.map((role) => (
                      <option key={role.id} value={role.id.toString()}>
                        {role.role}
                      </option>
                    ))}
                  </select>

              <Input
                type="text"
                value={searchInput}
                disabled={loading ? true : false}
                onChange={(e) => handleSearchInputChange(e)}
                className="form-control w-25"
                placeholder="Search Tasks "
              />
            </div>
          </Col>

          <Col md={12} className="p-2">
            <div className="d-flex">
              <>

                {props.workflowPhases
                  ? props.workflowPhases.map((phase) => (
                    <>
                        <div
                          onClick={() => {
                            if (!loading) {
                              setCurrentPhaseId(phase.id);
                            }
                          }}
                          style={{
                            cursor: loading ? "not-allowed" : "pointer",
                            opacity: loading ? 0.5 : 1
                          }}
                          className={
                            phase.id == currentPhaseId
                              ? "selected-tab-workflows m-2"
                              : "pt-3 pb-3 m-2"
                          }
                        >
                          <p className="text-center p-0 mb-0" style={{ fontSize: '17px' }} key={phase.id}>
                            <b>{phase.name}</b>
                          </p>
                          {workflowPhaseCount
                            && workflowPhaseCount.map((count) => (
                              <p className="text-center p-0 mb-0">
                                {phase.id === count.WorkflowPhases_id
                                  ? count.attemptedTaskCount +
                                  " of " +
                                  count.taskCount +
                                  " Completed"
                                  : ""}
                              </p>
                            ))
                          }

                        </div>
                    </>
                  ))
                  : ""}
              </>
            </div>
          </Col>
        </Row>
      </Card>
      <>

        <Card>
          <Col md={12} className='pb-4'>
            <table className="table">
              <thead>
                <tr>
                  <th>Task</th>
                  <th>Role</th>
                  <th>Active</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      <b>Loading task data...</b>
                    </td>
                  </tr>
                ) : taskList && taskList.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : (
                    getFilteredTasks().map(function (task) {
                      const currentValue =
                        changedRoles[task.id] !== undefined
                          ? changedRoles[task.id]
                          : task.roleId;
                      return (
                        <tr key={task.id}>
                          <td style={{ width: "40%" }}>
                            {task.taskText}
                          </td>

                          <td style={{ width: "30%" }}>
                            <select
                              className="form-control w-75"
                              value={currentValue ? currentValue.toString() : ""}
                              onChange={(e) => handleRoleChange(task.id, e.target.value)}
                            >
                              <option value="">--Select Role--</option>

                              {rolesList.map((role) => (
                                <option key={role.id} value={role.id.toString()}>
                                  {role.role}
                                </option>
                              ))}
                            </select>
                          </td>

                          <td style={{ width: "30%" }}>
                            <input
                              type="checkbox"
                              checked={task.isActive || false}
                              onChange={function () {
                                handleActiveChange(task);
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })
                )}
              </tbody>
            </table>
          </Col>
        </Card>
      </>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    accessLevel: state.loggedUser.accessLevel,
    status: state.loggedUser.status,
    error: state.loggedUser.error,
    storeOverview: state.accountOverview.store.storeOverview,
    storeProducts: state.accountOverview.store.storeProducts,
    newUser: state.loggedUser.newUser,
    needsAdvertisingAPIAuth: state.loggedUser.needsAdvertisingAPIAuth,
    user: state.LWA.user,
    isAuth: state.LWA.isAuth,
    enableMobileMenu: state.theme.enableMobileMenu,
    enableClosedSidebar: state.theme.enableClosedSidebar,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(WorkflowSettings);
